import * as React from 'react';
import { Button, PRIORITY, SIZE } from 'wix-ui-tpa/Button';

import { st, classes } from './Button.st.css';

const ButtonComponent = ({
  id,
  isMobile,
  content,
  onClick,
  disabled = false,
  fullWidth,
  size,
  isOldStyle,
}) => {
  return (
    <Button
      id={id}
      className={st(classes.root, { isMobile, isOldStyle })}
      fullWidth={fullWidth}
      disabled={disabled}
      onClick={onClick}
      size={size || SIZE.medium}
      priority={PRIORITY.basicSecondary}
    >
      {content}
    </Button>
  );
};

export default ButtonComponent;
